var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "of79643iba",
    cx: 75,
    cy: 75,
    r: 75
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-411 -5241) translate(411 5241)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bdccjzgrab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#of79643iba"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F5F6FA",
    xlinkHref: "#of79643iba"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bdccjzgrab)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#82889C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.625 22.918c-6.318 0-11.457-5.14-11.457-11.457C9.168 5.142 14.307 0 20.625 0c6.318 0 11.457 5.14 11.457 11.457 0 6.318-5.139 11.46-11.457 11.46z",
    transform: "translate(53 50)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.887.036C4.88.036 0 4.916 0 10.922v8.02c0 .938.78 1.719 1.719 1.719h21.199v-7.45c0-4.307 3.207-7.861 7.356-8.48.595-1.743 1.719-3.207 3.163-4.262-2.293-.653-2.417-.433-22.55-.433z",
    transform: "translate(53 50) translate(0 27.464)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.887.071C14.88.071 10 4.953 10 10.958v8.02c0 .938.78 1.718 1.719 1.718h21.199v-7.449c0-4.307 3.207-7.861 7.356-8.48.595-1.743 1.719-3.207 3.163-4.263-2.293-.653-2.417-.433-22.55-.433z",
    transform: "translate(53 50) translate(0 27.464) matrix(-1 0 0 1 53.437 0)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDefault);
export default __webpack_public_path__ + "static/media/profile_default.e6c278e71118ae6ecbe831fca1c229a2.svg";
export { ForwardRef as ReactComponent };